import request from '@/utils/request'

export function physicalWarehouseList(data) {
  return request({
    url: '/mg/daohang-stock-api/centralWarehouse/list',
    method: 'post',
    data,
  })
}

export function logicWarehouseList(data) {
  return request({
    url: '/mg/daohang-stock-api/cargoWarehouse/list',
    method: 'post',
    data,
  })
}

/**
 * 经营组织下对应的仓库查询
 * @returns
 */
export function fetchCargoWarehouseListByBusinessGroup(data) {
  return request({
    url: '/mg/daohang-stock-api/businessCargoWarehouse/list',
    method: 'post',
    data,
    allowRepeat: true,
  })
}
